// extracted by mini-css-extract-plugin
export default {"search":"styles_search__29-N0","marginLeft":"styles_marginLeft__x+CTV"};